import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { Button, OverlayTrigger, Popover } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '../../i18n';
import { AvailableColumnFilters } from './AvailableColumnFilters';
import { SelectedColumnFilter } from './SelectedColumnFilter';
export function ColumnFilter(props) {
    const { initialValue, initialType, filters, isActive, onChange } = props;
    const [value, setValue] = useState(initialValue || '');
    const [selectedType, setSelectedType] = useState(initialType || filters[0].type);
    const [isValid, setIsValid] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const inputRef = useRef(undefined);
    const { t } = useI18n();
    const applyFilterButtonText = t('component.grid.applyFilter');
    const filterButtonText = t('component.grid.filter');
    const focusInput = ()=>inputRef.current?.focus();
    const onTypeChange = (e)=>{
        setSelectedType(e.target.value);
        setValue('');
        setIsValid(true);
        focusInput();
    };
    const selectedFilter = filters.find((x)=>x.type === selectedType);
    const initialFilter = filters.find((x)=>x.type === initialType);
    const onValueChange = useCallback((e)=>{
        if (!isValid) {
            setIsValid(!e.target.value || selectedFilter.validate(e.target.value));
        }
        setValue(e.target.value);
    }, [
        selectedFilter,
        isValid,
        setIsValid
    ]);
    const onSubmit = useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        const val = !value || selectedFilter.validate(value);
        setIsValid(val);
        if (val) {
            onChange(selectedFilter, value);
            setShowFilter(false);
        }
    }, [
        value,
        selectedFilter,
        onChange
    ]);
    const popoverBottom = /*#__PURE__*/ _jsx(Popover, {
        id: "ColumnFilterPopover",
        children: /*#__PURE__*/ _jsxs("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ _jsx(AvailableColumnFilters, {
                    filters: filters,
                    value: selectedType,
                    onChange: onTypeChange
                }),
                /*#__PURE__*/ _jsx(SelectedColumnFilter, {
                    ref2: inputRef,
                    filter: selectedFilter,
                    value: value,
                    onChange: onValueChange,
                    isValid: isValid
                }),
                /*#__PURE__*/ _jsxs(Button, {
                    type: "submit",
                    bsSize: "sm",
                    bsStyle: "primary",
                    children: [
                        /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: faFilter
                        }),
                        " ",
                        applyFilterButtonText
                    ]
                })
            ]
        })
    });
    const buttonText = isActive ? `${initialFilter.shortname} ${initialValue}` : filterButtonText;
    return /*#__PURE__*/ _jsx(OverlayTrigger, {
        show: showFilter,
        onToggle: (nextShow)=>setShowFilter(nextShow),
        trigger: "click",
        rootClose: true,
        placement: "bottom",
        overlay: popoverBottom,
        onEntered: focusInput,
        children: /*#__PURE__*/ _jsx("div", {
            className: "d-grid",
            children: /*#__PURE__*/ _jsxs(Button, {
                bsSize: "sm",
                bsStyle: isActive ? 'success' : 'default',
                children: [
                    /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                        icon: faFilter
                    }),
                    " ",
                    buttonText
                ]
            })
        })
    });
}
